import React, { useMemo } from 'react';
import { Divider, Grid, Icon, Link, styled, Typography } from '@mui/material';
import { IDriverRequest } from '../types';
import { FieldList } from '../config';
import { FIELDS } from '../fields';


const SpacingGrid = styled(Grid)(({ theme }) => ({
  marginTop: '0 !important',
  marginBottom: '0 !important',
  "& >div": {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  }
}));

const DividerBox = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  marginLeft: theme.spacing(-3),
  marginRight: theme.spacing(-3),
}));

interface IProps {
  instance: IDriverRequest;
}

const fields:FieldList = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'referrer',
  'source',
  'is_only_for_level_1',
]

export default function InstanceModalInfo(props:IProps) {
  const {
    instance
  } = props;

  const values = useMemo(()=>{
    let v = fields.map((field_name) => {
      let value = instance[field_name];
      if(value === true){
        value = "Так"
      }else if(value === false){
        value = "Ні"
      }
      return {
        title: FIELDS[field_name].title,
        value: value || null
      };
    })
    return v.filter((value)=>value.value!==null)
  }, [instance])

  if(!values.length) return null;

  return (
    <React.Fragment>
      <DividerBox/>
      <SpacingGrid container spacing={3}>
        {instance.cv?(
          <Grid item xs={12} md={6}>
            <Link href={instance.cv} target="_blank">{FIELDS.cv.title} <Icon fontSize="inherit">open_in_new</Icon></Link>
          </Grid>
        ):null}
        {values.map((value, index)=>{
          return (
            <Grid key={index} item xs={12} md={6}>
              <Typography variant="caption" color="textSecondary">{value.title}:</Typography> {value.value}
            </Grid>
          )
        })}
      </SpacingGrid>
    </React.Fragment>
  );
}